import { DependentMedicalCondition } from './dependent-medical-condition';
import { Member } from './member';
import { Scheme } from './scheme';
import { User } from './user';

export class Dependent {
  member_number!: string;
  beneficiary_number!: string;
  date_joined!: number;
  effective_date?: number;
  title!: string;
  first_name!: string;
  middle_name?: string;
  last_name!: string;
  sex!: string;
  relationship!: string;
  date_of_birth!: number;
  national_id?: string;
  national_id_path?: string;
  member_profile_image_path?: string;
  registered_doctor?: string;
  registered_doctor_contact_number?: string;
  has_previous_medical_aid!: boolean;
  previous_medical_aid_fund?: string;
  previous_medical_aid_plan?: string;
  previous_medical_aid_path?: string;
  previous_medical_aid_from_date?: number;
  previous_medical_aid_to_date?: number;
  street_address?: string;
  city?: string;
  country?: string;
  phone_number?: string;
  whatsapp_number?: string;
  email?: string;
  date_approved?: number;
  beneficiary_status!: string;
  company_beneficiary_status!: string;
  funder_beneficiary_status!: string;
  has_pending_termination_request?: boolean;           // maker-checker — attached on show when pending
  is_student!: boolean;
  student_id_path?: string;
  notes?: string;
  mobile_money_service?: string;
  mobile_money_phone_number?: string;
  bank_name?: string;
  bank_account_name?: string;
  bank_branch?: string;
  bank_account_number?: string;
  payment_method!: string;
  membership_card_status!: string;
  membership_card_number?: string;
  membership_card_expiry_date?: string;
  // Stage 4 PR 3, 2026-05-13 — operator-captured card issuance.
  membership_card_name_on_card?: string;
  membership_card_date_issued?: number;
  membership_card_issued_by_user_uuid?: string;
  scheme_code!: string;
  date_deleted?: number;
  uuid!: string;
  user_uuid!: string;
  date_created!: number;
  date_updated!: number;

  dependent_medical_conditions?: Array<DependentMedicalCondition>;
  member?: Member;
  user?: User;
  scheme?: Scheme;

  getFullMemberNumber() {
    return `${this.member_number}-${this.beneficiary_number}`;
  }

  isDraft() {
    return this.beneficiary_status.toLocaleLowerCase() == 'draft';
  }


  isPendingPayment() {
    return this.beneficiary_status.toLocaleLowerCase() == 'pending_payment';
  }

  getBeneficiaryNumberAsInt() {
    return parseInt(this.beneficiary_number);
  }

  companyStatusIsActive() {
    return this.company_beneficiary_status.toLocaleLowerCase() == 'active';
  }

  companyStatusIsPending() {
    return this.company_beneficiary_status.toLocaleLowerCase() == 'pending';
  }

  companyStatusIsSuspended() {
    return this.company_beneficiary_status.toLocaleLowerCase() == 'suspended';
  }

  getFullName() {
    return `${this.first_name} ${this.last_name}`;
  }

  isPending() {
    return this.beneficiary_status.toLocaleLowerCase() == 'pending';
  }
  isActive() {
    return this.beneficiary_status.toLocaleLowerCase() == 'active';
  }

  isSuspended() {
    return this.beneficiary_status.toLocaleLowerCase() == 'suspended';
  }

    isLapsed() {
      return this.beneficiary_status.toLocaleLowerCase() == 'lapsed';
    }

  isTerminated() {
    return this.beneficiary_status.toLocaleLowerCase() == 'terminated';
  }

  // maker-checker — true while a termination request is awaiting a second
  // authorised user's approval. Drives the "Approve Termination" button + hides
  // "Request Termination". Mirrors Member.hasPendingTerminationRequest().
  hasPendingTerminationRequest(): boolean {
    return this.has_pending_termination_request === true;
  }

  paymentMethodIsMobile() {
    return this.payment_method?.toLocaleLowerCase() == 'mobile_money';
  }

  constructor(data: any) {
    this.member_number = data.member_number;
    this.beneficiary_number = data.beneficiary_number;
    this.date_joined = data.date_joined;
    this.effective_date = data.effective_date;
    this.title = data.title;
    this.first_name = data.first_name;
    this.middle_name = data.middle_name;
    this.last_name = data.last_name;
    this.sex = data.sex;
    this.relationship = data.relationship;
    this.date_of_birth = data.date_of_birth;
    this.national_id = data.national_id;
    this.national_id_path = data.national_id_path;
    this.member_profile_image_path = data.member_profile_image_path;
    this.registered_doctor = data.registered_doctor;
    this.registered_doctor_contact_number =
      data.registered_doctor_contact_number;
    this.previous_medical_aid_fund = data.previous_medical_aid_fund;
    this.previous_medical_aid_plan = data.previous_medical_aid_plan;
    this.previous_medical_aid_path = data.previous_medical_aid_path;
    this.previous_medical_aid_from_date = data.previous_medical_aid_from_date;
    this.previous_medical_aid_to_date = data.previous_medical_aid_to_date;
    this.phone_number = data.phone_number;
    this.whatsapp_number = data.whatsapp_number;
    this.email = data.email;
    this.street_address = data.street_address;
    this.city = data.city;
    this.country = data.country;
    this.date_approved = data.date_approved;
    this.beneficiary_status = data.beneficiary_status;
    this.company_beneficiary_status = data.company_beneficiary_status;
    this.funder_beneficiary_status = data.funder_beneficiary_status;
    this.has_pending_termination_request = data.has_pending_termination_request;
    this.is_student = data.is_student;
    this.student_id_path = data.student_id_path;
    this.notes = data.notes;
    this.mobile_money_service = data.mobile_money_service;
    this.mobile_money_phone_number = data.mobile_money_phone_number;
    this.bank_name = data.bank_name;
    this.bank_account_name = data.bank_account_name;
    this.bank_branch = data.bank_branch;
    this.bank_account_number = data.bank_account_number;
    this.payment_method = data.payment_method;
    this.membership_card_status = data.membership_card_status;
    this.membership_card_number = data.membership_card_number;
    this.membership_card_expiry_date = data.membership_card_expiry_date;
    this.membership_card_name_on_card = data.membership_card_name_on_card;
    this.membership_card_date_issued = data.membership_card_date_issued;
    this.membership_card_issued_by_user_uuid = data.membership_card_issued_by_user_uuid;
    this.scheme_code = data.scheme_code;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.user_uuid = data.user_uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.dependent_medical_conditions) {
      this.dependent_medical_conditions = data.dependent_medical_conditions.map(
        (el: any) => new DependentMedicalCondition(el)
      );
    }

    if (data.member) {
      this.member = new Member(data.member);
    }
    if (data.scheme) {
      this.scheme = new Scheme(data.scheme);
    }
    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
